export default {"src":"/_next/static/media/fish.23cbe8bb.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};